import React from "react";

export function LeftArrowIcon() {
    return <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.6022 2.51743C9.1641 1.9087 9.12614 0.959707 8.51741 0.397802C7.90868 -0.164103 6.95969 -0.126144 6.39779 0.482587L0.397795 6.98258C-0.132598 7.55717 -0.132598 8.44283 0.397795 9.01742L6.39779 15.5174C6.95969 16.1261 7.90868 16.1641 8.51741 15.6022C9.12614 15.0403 9.1641 14.0913 8.6022 13.4826L3.54136 8L8.6022 2.51743Z" fill="none"/>
    </svg>;
}
